import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { TrackingEventName } from "./tracking";
import { useTrackPromocode } from "./useTrackPromocode";

interface TrackPromocodeValidFunctionArgs {
  readonly promocode: string;
}

interface TrackPromocodeValidFunction {
  (args: TrackPromocodeValidFunctionArgs): void;
}

interface UseTrackPromocodeValidFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackPromocodeValidFunction {
  (agrs: UseTrackPromocodeValidFunctionArgs): TrackPromocodeValidFunction;
}

const useTrackPromocodeValid: UseTrackPromocodeValidFunction = ({ country, segment, tradename, userId }) => {
  const trackPromocode = useTrackPromocode({
    event: TrackingEventName.PROMOCODE_VALID,
    country,
    segment,
    tradename,
    userId,
  });

  const trackPromocodeValid: TrackPromocodeValidFunction = useCallback(
    ({ promocode }) => {
      trackPromocode({ promocode });
    },
    [trackPromocode],
  );

  return trackPromocodeValid;
};

export { useTrackPromocodeValid };
